import { Injectable } from '@angular/core';
import { RollbarErrorHandler } from '@becksdevteam/rollbar-angular';

@Injectable()
export class GlobalErrorHandler extends RollbarErrorHandler {
  // Info on the 'Script Error' error - https://docs.rollbar.com/docs/unknown-script-error
  private noisyJavascriptErrors = ['ResizeObserver loop completed with undelivered notifications', 'Script error'];
  // biome-ignore lint/suspicious/noExplicitAny: existing any, to be typed incrementally
  handleError(err: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const failedToFetchLazyLoadedModuleMessage = 'Failed to fetch dynamically imported module';

    if (
      err?.message &&
      (chunkFailedMessage.test(err.message) || err.message.includes(failedToFetchLazyLoadedModuleMessage))
    ) {
      // force the app to reload and fetch the new chunks
      window.location.reload();
      return;
    }

    // Prevent sending noisy javascript errors to rollbar
    if (
      err?.message &&
      this.noisyJavascriptErrors.some((noisyError) => err.message.toLowerCase().includes(noisyError.toLowerCase()))
    ) {
      return;
    }

    // log error with Rollbar and to console
    super.handleError(err);
  }
}
